import ActionForm from '@/mixins/ActionForm'
// import PedidoController from "@/shared/controllers/pedido/PedidoController";

const name = 'InfoClientePedido'

export default {
  name,  
  mixins: [ActionForm],

  components: { },

  props: { },

  mounted () { 
    this.popularDadoscliente();
    this.ImagemEmpresa()
  },

  updated () { },

  data () {
    return {
      informacaoCliente: null,
      popup: false,
      ClienteId: null,
      ICMS: false,
      IPI:false,
      PisCofins: false,
      clienteSituacao:null,
      popupCompletarCadastroCliente: false,
      imagemEmpresa: ''
    }
  },

  methods: {
    ImagemEmpresa(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetNomeEmpresaByPedidoId/${this.$route.params.id}`,
      })
        .then((response) => {

          this.NomeEmpresa=response.data.message

          const nomeEmpresa = () => {
            if(this.NomeEmpresa.includes('SUPREMA')) return 'SUPREMA';
            if(this.NomeEmpresa.includes('NORDESTE')) return 'NORDESTE';
            return 'JAUENSE'
          }
  
          const urlBase = window.location.host
          this.imagemEmpresa =  `http://${urlBase}/repositorio/${nomeEmpresa()}/LOGOTIPO.png`;
        })
        .catch();
    },
    modificar(){
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + 'Cliente/verificacliente',
        data:
        {
          Id: this.ClienteId
        }
      })
        .then((response) => {
          this.$store.state.cliente = response.data.data       

          let arrayAjustado = response.data.data.clienteAgrupadores.map(e => { //TODO
            return this.converteClienteAgrupador(e)
          })

          this.$store.state.cliente.clienteAgrupadores = arrayAjustado

          this.$store.commit('salvando');

          this.situacaoVindaDoBanco= response.data.data.clienteSituacao

          if(response.data.data != null){
            this.popupjaexiste=true;
          }

          this.clienteSituacao
          if (this.clienteSituacao === 0){
            this.$router.push(`/ficha-cadastro/${this.ClienteId}`)
        } else
          {
          this.$router.push(`/cliente-em-desenvolvimento/${this.ClienteId}`)
        }
        })
        .catch();
    },

    converteClienteAgrupador(obj){
      /*
        Para sincronizar o multi select com a tabela, é necessário que a lista dos dois tenha o mesmo padrão de objeto.
        No caso,
        {
          codigoUsuario,
          id (do cliente)
          nomeFantasia
        }
        Os clientes disponiveis para selecionar vem de dois metodos diferentes do back, de duas forma diferentes, por isso é necessário
        padronizar a lista.
      */
      return {
        codigoUsuario: obj.codigo || obj.codigoUsuario,
        id: obj.clienteId || obj.id,
        nomeFantasia: obj.nomeFantasia,
      }
    },

    popularDadoscliente(){
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Cliente/GetClienteByPedidoId/${this.$route.params.id}`,
      })
        .then((response) => {
          this.GetResultForm(response)
          this.ClienteId = response.data.data.id     
          this.ICMS = this.objForm.icms
          this.IPI = this.objForm.ipi
          this.PisCofins = this.objForm.pisCofins
          this.incentivos()
          this.clienteSituacao=response.data.data.clienteSituacao
        })
        .finally(()=> {
          this.$isLoading(false)
        })
    },

    incentivos(){
      this.incentivos
      if (this.ICMS === true){
      this.ICMS = ("ICMS   ")
      } else{
      this.ICMS = ("")
      }

      if (this.IPI === true){
      this.IPI = ("IPI   ")
      } else{
      this.IPI = ("")
      }

      if (this.PisCofins === true){
      this.PisCofins = ("PisCofins")
      } else{
        this.PisCofins = ("")
      }
    },
    redireciona(){
      this.EditarCliente(this.informacaoCliente)
    },

    abrePopup (infoCliente) {
      this.popup=true
      this.informacaoCliente = infoCliente
    },

    fechaPopup(){
      this.popup = false
    },

    EditarCliente() {
      this.$router.push('/ficha-cadastro')
    },

    Continuar() {
      // if (this.clienteSituacao === 0) {
      //   this.$router.push(`/gerar-novo-pedido/${this.$route.params.id}/info-frete-pedido`)
      // } else  {
      //   this.popupCompletarCadastroCliente = true;
      // }

      // this.popupCompletarCadastroCliente = true;
      this.$router.push(`/gerar-novo-pedido/${this.$route.params.id}/info-frete-pedido`)
    },

    Voltar() {
      this.$router.push('/gerar-novo-pedido-orcamento')
    },

    redirecionaFichaCadastral() {
      this.$router.push(`/ficha-cadastro/${this.ClienteId}`)
    },
    fechaPopupCadastroCliente() {
      this.popupCompletarCadastroCliente = false
    },
    teste() {
       this.$router.push(`/gerar-novo-pedido/${this.$route.params.id}/info-frete-pedido`)
    }
   },

  computed: { },

};